import { Phone, MessageCircle, ClipboardCheck } from "lucide-react";
import { SITE } from "../config/site";
import { useLead } from "../context/LeadContext";

export const StickyMobileCTA = () => {
  const { openModal } = useLead();
  return (
    <div data-testid="sticky-mobile-cta" className="fixed bottom-0 inset-x-0 z-40 md:hidden grid grid-cols-3 border-t border-charcoal/20 bg-ivory">
      <a data-testid="sticky-call-btn" href={SITE.phoneHref} className="flex flex-col items-center justify-center gap-1 py-3 text-charcoal active:bg-sand transition-colors">
        <Phone className="h-4 w-4" />
        <span className="text-[10px] font-bold tracking-[0.12em] uppercase">Call Now</span>
      </a>
      <button data-testid="sticky-book-btn" onClick={() => openModal()} className="flex flex-col items-center justify-center gap-1 py-3 bg-wine text-ivory active:bg-wine-light transition-colors">
        <ClipboardCheck className="h-4 w-4" />
        <span className="text-[10px] font-bold tracking-[0.12em] uppercase">Free Inspection</span>
      </button>
      <a data-testid="sticky-whatsapp-btn" href={SITE.whatsappHref} target="_blank" rel="noopener noreferrer" className="flex flex-col items-center justify-center gap-1 py-3 bg-[#1FA855] text-ivory shadow-[0_0_18px_rgba(31,168,85,0.5)] active:bg-[#23c05f] transition-colors">
        <MessageCircle className="h-4 w-4" />
        <span className="text-[10px] font-bold tracking-[0.12em] uppercase">WhatsApp</span>
      </a>
    </div>
  );
};
